const BITTE_BLACK_IMG =
  'https://storage.googleapis.com/bitte-public/symbol-dark.svg';
const BITTE_IMG =
  'https://storage.googleapis.com/bitte-public/symbol-light.svg';

export { BITTE_BLACK_IMG, BITTE_IMG };
